import { getIdentity } from '@sdc/auth';

/**
 * Schreibt einen Eintrag ins Auth-Audit-Log.
 *
 * `user_id` muss gesetzt werden, weil die RLS-Policy `user_id = auth.uid()`
 * verlangt (IMPLEMENTATION §4). Fehler werden geschluckt – Logging darf keinen
 * Login und keinen Logout blockieren.
 */
export async function logAuditEvent(
  event: 'login' | 'logout' | 'app_access',
  meta: Record<string, unknown> = {},
  appSlug: string | null = null,
): Promise<void> {
  try {
    const identity = getIdentity();
    const {
      data: { session },
    } = await identity.auth.getSession();
    const userId = session?.user.id;
    if (!userId) return;

    await identity
      .from('auth_audit_log')
      .insert({ user_id: userId, event, app_slug: appSlug, meta });
  } catch {
    /* Audit-Log ist best effort */
  }
}
